import { configureStore } from "@reduxjs/toolkit";
import citizenshipFormReducer from "./slices/Citizenship/citizenshipFormSlice";
import viewDocumentReducer from "./slices/Citizenship/viewDocumentSlice";
import managerPortalReducer from "./slices/Citizenship/managerPortalSlice";
import profileReducer from "./slices/profileSlice";
import tuitionApplyReducer from "./slices/Tuition/tuitionApplySlice";
import tuitionViewMyStatusReducer from "./slices/Tuition/tuitionViewMyStatusSlice";
import { tuitionManagerPortalReducer } from "./slices/Tuition/tuitionManagerPortalSlice";
import adminReducer from "./slices/Citizenship/adminSlice";
import tuitionAdminReducer from "./slices/Tuition/tuitionAdminSlice";
import manageCannedResponseSlice from "./slices/Tuition/manageCannedResponseSlice";
import loaderReducer from "./slices/loaderSlice";
import administerReducer from "./slices/Tuition/administerSlice";

export const store = configureStore({
  reducer: {
    profile: profileReducer,
    citizenshipForm: citizenshipFormReducer,
    viewDocument: viewDocumentReducer,
    managerPortal: managerPortalReducer,
    tuitionApply: tuitionApplyReducer,
    tuitionViewMyStatus: tuitionViewMyStatusReducer,
    tuitionManagerPortal: tuitionManagerPortalReducer,
    admin: adminReducer, 
    tuitionAdmin: tuitionAdminReducer,
    tuitionManageCannedResponse: manageCannedResponseSlice,
    loader: loaderReducer,
    administer: administerReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
